<template>
  <l-cascader
    :label="label"
    :prepend-icon="prependIcon"
    :no-data-text="noDataText_"
    v-bind="$attrs"
    :items="rules"
    item-value="id"
    content-width="250"
    item-text="name"
    @input="$emit('input', $event)"
    :value="value"
  ></l-cascader>
</template>

<script>
export default {
  name: 'selectViolationRule',
  props: {
    value: {},
    items: {
      type: Array
    },
    label: {
      type: String,
      default: '违章类型'
    },
    prependIcon: {
      type: String,
      default: '$vuetify.icons.description'
    },
    noDataText: {
      type: String
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    rules () {
      return this.items || this.$store.state.violation.ruleList || []
    },
    noDataText_ () {
      return this.loading ? '数据加载中...' : this.noDataText
    }
  },
  async created () {
    if (!this.items && !this.rules.length) {
      try {
        this.loading = true
        await this.$store.dispatch('violation/getRules', {useCache: true})
      }
      catch (e) {
        this.$L.error(e.message)
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
